export class ThresholdStep {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "value",
            "baseName": "value",
            "type": "number",
            "format": "double"
        },
        {
            "name": "color",
            "baseName": "color",
            "type": "HealthStatus",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ThresholdStep.attributeTypeMap;
    }
    constructor() {
    }
}
